export enum ShareModes {
    TEST = "TEST",
    PRACTICE = "PRACTICE",
}

export enum ShareSteps {
    MODE = "MODE",
    CLASS = "CLASS",
    TIMING = "TIMING",
    DETAILS = "DETAILS",
}

export enum ShareTimings {
    NOW = "NOW",
    LATER = "LATER",
}

// Sentinel value for "Keine Klasse auswählen" — distinguishes explicit "no class" from "nothing selected yet" (null)
export const NO_CLASS_SELECTION = "NO_CLASS" as const;
